var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-popup',{attrs:{"max-width":"400","cons":_vm.cons},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[[_c('h4',{staticClass:"p-2 text-center"},[_vm._v(" آیا از تصمیم خود برای حذف کد تخفیف اطمینان دارید ؟ ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }